<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <app-input class="m-1" size="0" [label]="'search'" [formControl]="form_name"
      (valueChanged)="updateDataFromFilters()" [prefixIcon]="'search'"></app-input>

    <mat-accordion class="m-1">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Filtres
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="form-group">
          <app-select class="m-1" [label]="'type'" [formControl]="form_type" [list]="availableTypes"
            [isMultiple]="false" [isEnum]="true" enumName="PaymentType"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <app-select class="m-1" [label]="'status'" [formControl]="form_status" [list]="availableStatus"
            [isMultiple]="false" [isEnum]="true" enumName="PaymentStatus"
            (valueChanged)="updateDataFromFilters()"></app-select>

          <app-input class="m-1" size="0" [label]="'dateStart'" type="datetime-local" [formControl]="form_dateStart"
            (valueChanged)="updateDataFromFilters()"></app-input>
          <app-input class="m-1" size="0" [label]="'dateEnd'" type="datetime-local" [formControl]="form_dateEnd"
            (valueChanged)="updateDataFromFilters()"></app-input>

          <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
            colonnes</mat-slide-toggle>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
  <mat-divider></mat-divider>
  <div class="table-container">
    <div class="loading" *ngIf="isLoadingResults">
      <mat-spinner color="primary"></mat-spinner>
    </div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
      matSortDirection="desc">
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>État</th>
        <td mat-cell *matCellDef="let row" [class]="row.statusClass+' main'">{{ row.status }}</td>
      </ng-container>
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Effectué le</th>
        <td mat-cell *matCellDef="let row">{{ row.date | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="amountTaxExcl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Montant HT</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.amountTaxExcl |
          currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
      </ng-container>
      <ng-container matColumnDef="amountTaxIncl">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Montant TTC</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.amountTaxIncl |
          currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
      </ng-container>
      <ng-container matColumnDef="amountVat">
        <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>TVA</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.amountVat |
          currency:'EUR':'symbol':'1.2-2':'fr' }}</td>
      </ng-container>
      <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef>Utilisateur</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.user }}</td>
      </ng-container><ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef>Uid</th>
        <td mat-cell *matCellDef="let row">{{ row.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="externalId">
        <th mat-header-cell *matHeaderCellDef>ID Stripe</th>
        <td mat-cell *matCellDef="let row">{{ row.externalId }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class]="row.cssClass"></tr>
    </table>
  </div>

  <mat-paginator [length]="resultsLength" [pageSize]="paging.pagingPageSize"
    [pageSizeOptions]="paging.pagingPageSizeOptions" showFirstLastButtons></mat-paginator>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.stripeUrl">
        <a [href]="row.stripeUrl" target="_blank"><mat-icon color="primary">remove_red_eye</mat-icon><span
            class="text">Voir sur Stripe</span></a>
      </li>
    </ul>
  </ng-template>
</mat-menu>